import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminDashboard from "../Components/SchoolAdmin/Dashboard";
import CreateTheme from "../Components/SchoolAdmin/CreateTheme";
import EventList from "../Components/SchoolAdmin/EventList";
import EcoCalendar from "../Components/SchoolAdmin/EcoCalendar";
import EventAssignment from "../Components/SchoolAdmin/EventAssignment";
import FacultyManagement from "Components/SchoolAdmin/FacultyManagement";
import OutletRouteSchool from "../Components/OutletRouteSchool";
import SetLanguage from "../Components/SchoolAdmin/SetLanguage";
import EventManagement from "Components/SchoolAdmin/EventManagement";
import Notification from "Components/SchoolAdmin/Notification";
import { useSelector } from "react-redux";
import PasswordUpdate from "../Pages/PasswordUpdate"
import Certificate from "../Components/Certificate";
import SwachhataCertificatePage from "../Components/SchoolAdmin/Swachhata/SwachhataCertificatePage";
import RoleGuard from "../Components/RoleGuard";
import SwachhataStudents from "../Components/SchoolAdmin/SwachhataStudents";
import { EKPED3_SCHOOL_ENABLED } from "../config/campaigns";
import SpecialCampaign6 from "../Pages/SpecialCampaign6";
import BricsSustainableLifestyleWeek from "../Pages/BricsSustainableLifestyleWeek";

function SchoolRoutingPage() {

    const userData = useSelector(state => state.auth.user);
    const userRole = userData?.role;

    return (
        <>
            <Routes>
                <Route path="/school" element={<RoleGuard allowedRoles={[2]}><OutletRouteSchool /></RoleGuard>}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="schooldashboard" element={<AdminDashboard />} />
                    <Route path="password" element={<PasswordUpdate />} />
                    <Route path="createtheme" element={<CreateTheme />} />
                    <Route path="certificate" element={<Certificate />} />
                    {/* Ek Ped Maa Ke Naam 3.0 certificate — redirects while the campaign is off for schools */}
                    <Route path="certificate-3" element={EKPED3_SCHOOL_ENABLED ? <Certificate version="3.0" /> : <Navigate to="/school" replace />} />
                    {/* Swachhata Hi Seva: SWM Drive — participation certificate (after the quiz) */}
                    <Route path="swachhata-certificate" element={<SwachhataCertificatePage />} />
                    <Route path="eventmanagement" element={<EventManagement />} />
                    <Route path="eventlist" element={<EventList />} />
                    <Route path="ecocalendar" element={<EcoCalendar />} />
                    <Route path="faculty-manage" element={<FacultyManagement />} />
                    <Route path="event-assignment" element={<EventAssignment />} />
                    <Route path="set-language" element={<SetLanguage />} />
                    <Route path="notification" element={<Notification />} />
                    {/* Swachhata Hi Seva — students of this school who took the public quiz (participation only) */}
                    <Route path="swachhata-students" element={<SwachhataStudents />} />
                    {/* National Event on 28 Oct 2026 (Special Campaign 6): the school's own participation details, full edit */}
                    <Route path="special-campaign-6" element={<SpecialCampaign6 mode="school" />} />
                    <Route path="brics-sustainable-lifestyle-week" element={<BricsSustainableLifestyleWeek />} />
                    {/* RAS Activities routes removed — RAS 2025–26 submission is closed for schools. */}
                    <Route path="faculty/*" element={<Navigate to="/school" replace />} />
                </Route>
                {userRole === 2 && (
                    <Route path="admin/*" element={<Navigate to="/school" replace />} />
                )}
            </Routes>
        </>
    );
}

export default SchoolRoutingPage;
